import { connect } from 'react-redux';
import PrintWorkOrderModal from './PrintWorkOrderModal';
import { changeWorkOrderTemplate, close, confirm } from '../../../redux/modals/printWorkOrderModal'

const mapStateToProps = state => ({
  ...state.modals.printWorkOrderModal,
  templates: state.workOrders.workOrderTemplates
});

const mapDispatchToProps = {
  onConfirm: confirm,
  onHide: close,
  onWorkOrderTemplateChange: changeWorkOrderTemplate
};

export default connect(mapStateToProps, mapDispatchToProps)(PrintWorkOrderModal);
